import React from 'react';
import styled from 'styled-components';

const Holder = styled.div`
  position: fixed;
  z-index: 10;
  bottom: 1rem;
  right: 1rem;
  p {
    margin: 0;
    ${(props) => props.theme.fluidType(-1)};
  }
`;

function Footer() {
  return (
    <Holder>
      <p>
        <b>
          Based on{" "}
          <a
            href="https://flexiblevisualsystems.info/"
            target="_blank"
            rel="noopener noreferrer"
          >
            the work of Dr. Martin Lorenz.
          </a>
        </b>
        <br />
        <em>
          Built & designed by{" "}
          <a
            href="https://supermarket.london"
            target="_blank"
            rel="noopener noreferrer"
          >
            Supermarket
          </a>{" "}
          &{" "}
          <a
            href="https://publicwebsites.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            Public
          </a>
          .
        </em>
      </p>
    </Holder>
  )
}

export default Footer;